import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=6601b666&scoped=true&"
import script from "./Licenses.vue?vue&type=script&lang=js&"
export * from "./Licenses.vue?vue&type=script&lang=js&"
import style0 from "../OrgDefinitionsChildrens.css?vue&type=style&index=0&id=6601b666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6601b666",
  null
  
)

export default component.exports